import * as React from 'react';

import wsCarinaTheme from '../../configs/carina-theme';
import classNames from 'classnames';
const { ThemeProvider } = require('@cvent/carina-theme-provider');
const { Button } = require('@cvent/carina-button');

const styles = require('./MapRedoSearchControl.scss');
const controlStyles = require('./MapControl.scss');

interface Props {
    onClick: () => void;
}

export default function MapRedoSearchControl(props: Props) {
    return (
        <ThemeProvider theme={wsCarinaTheme}>
            <div className={classNames(controlStyles.mapControls, styles.redoButton)}>
                <Button text='Re-do Search In This Area' onClick={props.onClick} />
            </div>
        </ThemeProvider>
    );
}
